/*
  angularjs wrapper for svelte components:
  see admin/system_info_ctrl for example
*/

import camelCase from 'lodash/camelCase';

var upFirstLetter = function(name) {
  return name.charAt(0).toUpperCase() + name.slice(1)
}

var ctrl = function($scope, $timeout, $parse, $rootScope) {
  $timeout(function() {
    if (!$scope.svelteComponent) { return; }
    let props = {};
    var keys = Object.keys($scope.attrs);
    var bindings = []
    for (var attrName of keys) {
      if (attrName == 'props') { continue; }
      if (attrName.substring(0,4) == 'prop') {
        let propName = camelCase(attrName.substring(4,attrName.length));
        let getter = $parse($scope.attrs[attrName]);
        let propValue = getter($scope);
        props[propName] = propValue;
      } else if (attrName.substring(0,12) == 'bindPropDeep') {
        let propName = camelCase(attrName.substring(12,attrName.length));
        let expression = $scope.attrs[attrName];
        let getter = $parse(expression);
        let propValue = getter($scope);
        props[propName] = propValue;
        bindings[propName] = { expression: expression, getter: getter, deep: true };
      } else if (attrName.substring(0,8) == 'bindProp') {
        let propName = camelCase(attrName.substring(8,attrName.length));
        let expression = $scope.attrs[attrName];
        let getter = $parse(expression);
        let propValue = getter($scope);
        props[propName] = propValue;
        bindings[propName] = { expression: expression, getter: getter, deep: false };
      } else if (attrName.substring(0,7) == 'capProp') {
        let propName = upFirstLetter(camelCase(attrName.substring(7,attrName.length)));
        let getter = $parse($scope.attrs[attrName]);
        let propValue = getter($scope);
        props[propName] = propValue;
      }
    }

    if ($scope.attrs.props) {
      let getter = $parse($scope.attrs.props);
      let propsValue = getter($scope);
      Object.assign(props, propsValue);
    }

    if ($scope.attrs.dynamicProps) {
      let getter = $parse($scope.attrs.dynamicProps);
      let propsValue = getter($scope);
      Object.assign(props, propsValue);
      for (var key of Object.keys(propsValue)) {
        let expression = key;
        let getter = $parse(expression);
        bindings[key] = { expression: expression, getter: getter, deep: true };
      }
    }

    if (!$scope || !$scope.svelteComponent || !$scope[$scope.svelteComponent]) {
      if ($scope.svelteComponent && !$scope[$scope.svelteComponent] && window.RAILS_ENV == 'development') {
        console.error("angular-to-svelte component was not found", $scope.svelteComponent);
      }

      return;
    }

    $scope.obj = new $scope[$scope.svelteComponent]({
      target: document.getElementById('svelte-wrapper-' + $scope.$id),
      props: props
    });

    let setWatcher = false;
    for (let propName of Object.keys(bindings)) {
      let watch = bindings[propName];
      setWatcher = true;

      $scope.$watch(watch['expression'], function() {
        let attrs = {};
        attrs[propName] = watch['getter']($scope);
        $scope.obj.$set(attrs);
      }, watch.deep);
    }

    $rootScope.$watch('showLoading', function() {
      $scope.obj.$set({showLoading: $rootScope.showLoading});
    });

    // run an angularjs digest cycle in case some changes are left in the digest queue
    if (setWatcher) {
      $rootScope.safeApply()
    }

    // set 'svelteRef' on the angular container to get a reference to the created
    // svelte obj passed back
    if (_.get($scope, '$parent.svelteRef')) {
      $scope.$parent.svelteRef = $scope.obj;
    }
  }, 0, false);

  $scope.$on("$destroy", function() {
    if ($scope.obj && $scope.obj.$destroy) {
      $scope.obj.$destroy();
    }
  });
};

ctrl.$inject = ['$scope', '$timeout', '$parse', '$rootScope'];

tiz.controller('angularToSvelteCtrl', ctrl);
tiz.directive('angularToSvelte', function() {
  return {
    restrict: 'E',
    controller: 'angularToSvelteCtrl',
    scope: true,
    link: function(scope, elem, attrs) {
      scope.svelteComponent = attrs.svelteComponent
      scope.attrs = attrs;
      if (attrs.dynamicAttrs) {
        scope.dynamicAttrs = JSON.parse(attrs.dynamicAttrs)
      }
    },
    templateUrl: require('../templates/angular_to_svelte.html')
  };
});
